import {
	CssStyle,
	CssBorder,
	CssBorderColor,
	CssBorderRadius,
	CssBorderStyle,
	CssBorderWidth,
	CssBoxShadow,
	CssLength,
	CssColor,
	BoxShadowDefinition,
	ParsedCssBorder,
	ParsedCssBorderRadius,
	ParsedCssBoxShadow,
	ParsedCssStyle,
} from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

const length = (item: CssLength): string => (item.value ? `${item.value}${item.unit}` : '0')

const parseColor = (color: CssColor): string => `rgba(${color.red}, ${color.green}, ${color.blue}, ${color.alpha})`

const cssBoxShadow = (data: CssBoxShadow): ParsedCssBoxShadow => ({
	boxShadow: data
		.map((shadow: BoxShadowDefinition): string => {
			const inset = shadow.inset ? 'inset ' : ''
			const offsetX = length(shadow.offsetX)
			const offsetY = length(shadow.offsetY)
			const blurRadius = length(shadow.blurRadius)
			const spreadRadius = length(shadow.spreadRadius)
			const color = parseColor(shadow.color)

			return `${inset}${offsetX} ${offsetY} ${blurRadius} ${spreadRadius} ${color}`
		})
		.join(', '),
})

const cssBorderRadius = (data: CssBorderRadius): ParsedCssBorderRadius => {
	const radii = _.mapValues(data, length)

	return {
		borderRadius: `${radii.topLeft} ${radii.topRight} ${radii.bottomRight} ${radii.bottomLeft}`,
	}
}

const cssBorder = (data: CssBorder): ParsedCssBorder => {
	return {
		borderWidth: borderWidth(data.width),
		borderStyle: borderStyle(data.style),
		borderColor: borderColor(data.color),
	}
}

const borderWidth = (data: CssBorderWidth): string => _(data).mapValues(length).values().join(' ')

const borderStyle = (data: CssBorderStyle): string => _(data).values().join(' ')

const borderColor = (data: CssBorderColor): string => _(data).mapValues(parseColor).values().join(' ')

interface TransformationFunctions {
	[key: string]: (value: any) => any
}

const transformationFunctions: TransformationFunctions = {
	cssBoxShadow,
	cssBorderRadius,
	cssBorder,
}

const parseCss = (styleData: CssStyle): ParsedCssStyle => {
	return _(styleData)
		.pickBy((value) => value && !_.isEmpty(value))
		.mapValues((value, key) => transformationFunctions[key]?.(value) || null)
		.omitBy(_.isNull)
		.reduce(_.merge, {})
}

export { parseCss }
